/**
 * Prefill del código de referido desde query params / deep link.
 * El parámetro oficial es `referralCode`.
 */

import { normalizeReferralCode } from './referralCode';

const REFERRAL_QUERY_KEY = 'referralCode';

/**
 * Lee un parámetro de un objeto plano o de URLSearchParams.
 * @param {object|URLSearchParams} source
 * @param {string} key
 * @returns {string}
 */
function readParam(source, key) {
  if (!source) {
    return '';
  }
  if (typeof source.get === 'function') {
    return source.get(key) || '';
  }
  return source[key] || '';
}

/**
 * Devuelve el código de referido prellenado, o vacío.
 * @param {object|URLSearchParams} [params] Fuente explícita (tests)
 * @returns {string}
 */
export function getPrefillReferralCode(params) {
  const sources = [];

  if (params) {
    sources.push(params);
  } else {
    if (typeof window !== 'undefined' && window.mlsQueryParams) {
      sources.push(window.mlsQueryParams);
    }
    if (typeof window !== 'undefined' && window.location?.search) {
      sources.push(new URLSearchParams(window.location.search));
    }
  }

  for (let i = 0; i < sources.length; i += 1) {
    const value = normalizeReferralCode(
      readParam(sources[i], REFERRAL_QUERY_KEY),
    );
    if (value) {
      return value;
    }
  }

  return '';
}
